import AppFormContainer from '@nxsys/components/AppFormContainer';
import { Form } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import StepCard from './StepCard';
import { StyledAppSelect } from '@nxsys/components/AppSelect/index.styled';
import { starterTypeOptions } from '@nxsys/constants/AppConstants';
import AppCurrencyInput from '@nxsys/components/AppCurrencyInput';

interface AddP45DetailsProps {
  stepNumber: number;
  starterType?: string | null;
  p45GrossToDate?: number | null;
  p45TaxToDate?: number | null;
  completed?: boolean;
  onSubmitStep: (values: any) => void;
}

type AddP45DetailsValues = {
  starterType: string | null;
  p45GrossToDate: number | null;
  p45TaxToDate: number | null;
};

const AddP45Details: React.FC<AddP45DetailsProps> = ({
  stepNumber,
  starterType,
  p45GrossToDate,
  p45TaxToDate,
  completed = false,
  onSubmitStep,
}) => {
  const [form] = Form.useForm<AddP45DetailsValues>();
  const { messages } = useIntl();

  const selectedStarterType = Form.useWatch('starterType', form);

  const onFinish = (values: AddP45DetailsValues) => {
    const params = {
      p45Details: {
        starterType: values?.starterType || null,
        p45GrossToDate: values?.p45GrossToDate || null,
        p45TaxToDate: values?.p45TaxToDate || null,
      },
    };
    onSubmitStep(params);
  };

  return (
    <StepCard
      title={messages['prospect.onboarding.addP45Details'] as string}
      stepNumber={stepNumber}
      completed={completed}
      actions={[
        {
          variant: 'outlined',
          name: messages['common.save'] as string,
          onClick: () => form.submit(),
        },
      ]}
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        initialValues={{
          starterType: starterType ?? undefined,
          p45GrossToDate,
          p45TaxToDate,
        }}
        wrapperCol={{ span: 24 }}
        layout="vertical"
      >
        <Form.Item
          label={messages['prospect.onboarding.starterType'] as string}
          name="starterType"
          rules={[
            {
              required: true,
              message: messages['form.pleaseSelect'] as string,
            },
          ]}
        >
          <StyledAppSelect
            options={starterTypeOptions}
            placeholder={
              messages[
                'prospect.onboarding.starterDeclaration.placeholder'
              ] as string
            }
          />
        </Form.Item>

        {selectedStarterType === 'NEW_WITH_P45' && (
          <>
            <Form.Item
              label={messages['prospect.onboarding.p45GrossToDate'] as string}
              name="p45GrossToDate"
              rules={[
                {
                  required: true,
                  message: messages['form.pleaseEnter'] as string,
                },
              ]}
            >
              <AppCurrencyInput
                placeholder={`${messages['form.enter'] as string} ${
                  messages['prospect.onboarding.p45GrossToDate'] as string
                }`}
              />
            </Form.Item>

            <Form.Item
              label={messages['prospect.onboarding.p45TaxToDate'] as string}
              name="p45TaxToDate"
              rules={[
                {
                  required: true,
                  message: messages['form.pleaseEnter'] as string,
                },
              ]}
            >
              <AppCurrencyInput
                placeholder={`${messages['form.enter'] as string} ${
                  messages['prospect.onboarding.p45TaxToDate'] as string
                }`}
              />
            </Form.Item>
          </>
        )}
      </AppFormContainer>
    </StepCard>
  );
};

export default AddP45Details;
